import type { WritableComputedRef } from 'vue';
import Vue, { computed, getCurrentInstance } from 'vue';
import VueI18n from 'vue-i18n';
import { VueConstructor } from 'vue/types/umd';
import i18nInstance from '@/common/i18n';

export interface Composer {
  locale: WritableComputedRef<string>
  i18n: VueI18n
  t: typeof VueI18n.prototype.t
  tc: typeof VueI18n.prototype.tc
  te: typeof VueI18n.prototype.te
  d: typeof VueI18n.prototype.d
  n: typeof VueI18n.prototype.n
}

export function useI18n(): Composer {
  let i18n;
  try {
    i18n = i18nInstance;
  } catch (e) {
    console.log(e);
    throw new Error('vue-i18n not initialized');
  }

  const instance = getCurrentInstance();
  const vm = instance?.proxy
    || (instance as unknown as InstanceType<VueConstructor>)
    || new Vue({});

  const locale = computed({
    get() {
      return i18n.locale;
    },
    set(v: string) {
      i18n.locale = v;
    }
  });

  return {
    i18n,
    locale,
    t: vm.$t.bind(vm),
    tc: vm.$tc.bind(vm),
    d: vm.$d.bind(vm),
    te: vm.$te.bind(vm),
    n: vm.$n.bind(vm)
  };
}
